<template>
  <div class="add-member">
    <div class="title">
      <span>היי {{ firstName }},</span>
      <span>יהיו איתך שותפים נוספים בתזרים?</span>
    </div>
    <div class="subtitle">
      <span>אפשר להוסיף בן או בת זוג לתזרים ולקבל את ההחלטות הכלכליות ביחד.</span>
      <span class="bold">כל מה שצריך הוא לשתף את הלינק האישי ב-WhatsApp.</span>
    </div>
    <div class="top-button-wrapper">
      <riseup-button class="choose-members-button" :variant="'secondary'" :disabled="disabled" :title="'לשליחת לינק להצטרפות'" :action="addMember"/>
    </div>
    <div class="separator-wrapper">
      <span class="separator"/>
      <span class="separator-text">או</span>
      <span class="separator"/>
    </div>
    <div class="bottom-button-wrapper">
      <riseup-button class="choose-members-button" :disabled="disabled" :title="'לבניית התזרים'" :action="buildCasfhlow"/>
    </div>
    <support-footer/>
  </div>
</template>

<script>

import BaseUI from 'base-ui';
import { mapState, mapGetters } from 'vuex';
import Segment from '../../../../../Segment';
import config from '../../../../../config';

export default {
  name: 'AddMember',
  components: {
    RiseupButton: BaseUI.RiseupButton,
    SupportFooter: BaseUI.SupportFooter,
  },
  props: {
    next: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      disabled: false,
    };
  },
  async created() {
    Segment.trackUserGot('ChooseGroupMembersEntered');
  },
  computed: {
    ...mapGetters('session', ['firstName']),
    ...mapState('session', ['inviteToken']),
    addMemberLink() {
      return `${config.get().elsaPublicUrl}/invite?accessToken=${this.inviteToken}`;
    },
    addMemberMessage() {
      return encodeURIComponent(`היי! *נרשמתי ל-riseup!* אני מחכה לך בתזרים המשותף שלנו 🎯 כל מה שצריך לעשות בשביל להצטרף אליי זה *ללחוץ על הלינק המצורף* 👇 ${this.addMemberLink}`);// eslint-disable-line
    },
  },
  methods: {
    async addMember() {
      Segment.trackUserInteraction('InviteMemberClicked');
      window.open(`https://api.whatsapp.com/send?text=${this.addMemberMessage}`, '_blank');
    },
    async buildCasfhlow() {
      Segment.trackUserGot('BuildCashflowClicked');
      this.next();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../scss/mixins';

  .add-member {
    display: flex;
    flex-direction: column;
    margin: 30px;

    .title {
      @include white-page-frame-title;
      margin-bottom: 20px;
    }

    .subtitle {
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 30px;

      .bold {
        font-weight: bold;
      }
    }

    .choose-members-button {
      width: 100%;
    }

    .top-button-wrapper {
      margin-bottom: 20px;
      width: 100%;
    }

    .separator-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 30px;
      width: 100%;

      .separator {
        display: inline-block;
        width: 100%;
        height: 1px;
        background-color: $riseup_gray_2;
      }

      .separator-text {
        margin: 0 13px;
        font-size: 16px;
        font-weight: bold;
        color: $riseup_gray_2;
      }
    }

    .bottom-button-wrapper {
      margin-bottom: 75px;
      width: 100%
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/onboard/steps/AddMember.vue